import React, { useRef, useState } from 'react';
import {
  InputTextWrapper,
  IconLoading,
  ErrorMessage,
  Wrapper,
  IconView
} from './styled';
import { Icon } from '@app/src/common/Icon';

interface Props {
  type?: string;
  loading?: boolean;
  maxLength?: number;
  disabled?: boolean;
  placeholder?: string;
  handleChange?: Function;
  handleChangeInput?: Function;
  handleBlur?: Function;
  error?: string;
  value?: string;
  name?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
  className?: string;
  isEditable?: boolean;
}

export const Input: React.FC<Props> = ({
  type,
  loading,
  maxLength,
  disabled,
  placeholder,
  handleChange,
  handleChangeInput,
  handleBlur,
  error,
  value,
  name,
  iconLeft,
  iconRight,
  className,
  isEditable
}) => {
  const refInput = useRef(null);
  const [isShowPassword, setIsShowPassword ] = useState(false);

  const handleChangeProp = (e) => {
    handleChangeInput && handleChangeInput(e);
    handleChange && handleChange(e.target.value);
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleClickIconView = () => {
    setIsShowPassword(true);
    refInput.current.setAttribute('type', 'text');
  };

  const handleClickIconNotView = () => {
    setIsShowPassword(false);
    refInput.current.setAttribute('type', 'password');
  };

  return (
    <React.Fragment>
      <Wrapper className={className} disabled={disabled} isEditable={isEditable}>
        {iconLeft}
        <InputTextWrapper
          ref={refInput}
          name={name}
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChangeProp}
          onKeyPress={handleKeyPress}
          onBlur={handleBlur}
          maxLength={maxLength}
          disabled={disabled}
          error={error}
          iconLeft={iconLeft}
        />
        { loading && <IconLoading><Icon data-name='icon-circle' fill='#ccc' width="17" height="17" /></IconLoading> }
        {
          type === 'password' && !isShowPassword &&
            <IconView
              onClick={handleClickIconView}
              disabled={!value}
            >
              <Icon data-name="icon-view" width="20" height="20" fill={value ? '#333' : '#ccc'} />
            </IconView>
        }
        {
          type === 'password' && isShowPassword && <IconView onClick={handleClickIconNotView}><Icon data-name="icon-view" width="20" height="20" fill="#ccc" /></IconView>
        }
        {type !== 'password' && iconRight}
      </Wrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </React.Fragment>
)};
